import { CalculationInfoLegalNetherlands } from '~/app/compositions/content/calculation-info/core/calculation-info-legal-nl';
import { ConfigurationOverviewLegalNl } from '~/app/compositions/content/configuration-overview-legal-nl';
import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['electricRangeCombined', 'acceleration', 'speed', 'chargingTime'],
	financeDomain: 'AUDI.NL',
	financingDisclaimer: ['globalDisclaimer'],
	enablePriceDisclaimer: true,
	summaryFooterCta: {
		description: 'Audi Code',
		icon: 'code',
		labelText: 'Audi Code',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
};

export const local_ui: PartialUiConfiguration = {
	calculationInfoComponent: <CalculationInfoLegalNetherlands className="calculation" />,
	configOverviewComponent: <ConfigurationOverviewLegalNl />,
};
